import axios from 'axios'

const state = {
    crossSellings: [],
    crossSellingsLoading: false
}

const actions = {
    getCrossSellings({
        commit
    }, info) {
        commit('setCrossSellingsLoading', true)
        return new Promise((resolve, reject) => {
            axios.get('/api/crossSellings/' + info.codeArticle).then(response => {
                commit('setCrossSellings', response.data)
                commit('setCrossSellingsLoading', false)
                resolve(response)
            }).catch(error => {
                commit('setCrossSellingsLoading', false)
                reject(error)
            });
        });
    },
}


const getters = {
    crossSellings: state => state.crossSellings,
    crossSellingsLoading: state => state.crossSellingsLoading,
    currentPage: state => state.currentPage,
    totalPage: state => state.totalPage
}

const mutations = {
    setCrossSellings(state, crossSellings) {
        state.crossSellings = crossSellings
    },
    setCrossSellingsLoading(state, crossSellingsLoading) {
        state.crossSellingsLoading = crossSellingsLoading
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
